import ResourceService from '@/services/main/ResourceService';

class PageService extends ResourceService {
  constructor() {
    super('pages');
  }
}

export default new PageService();
